import { DeleteOutlined, EditOutlined, MoreOutlined } from "@ant-design/icons";
import { Button, Dropdown, Popconfirm, Table } from "antd";
import { EmptyState } from "@/shared/components/EmptyState";
import { useUrlTableState } from "@/shared/hooks/useUrlState";
import { formatTableIndex } from "@/shared/utils/formatTableIndex";
import { tablePagination } from "@/shared/utils/tablePagination";
import { useDeleteEquipmentType, useEquipmentTypes } from "../hooks/useEquipmentTypes";
import { useEquipmentTypesStore } from "../store/equipment-types.store";
import type { EquipmentType } from "../types";

export function EquipmentTypeTable() {
	const { onOpen } = useEquipmentTypesStore();
	const { page: currentPage, limit: pageSize, setPage } = useUrlTableState();
	const { data, isLoading } = useEquipmentTypes({
		page: currentPage,
		limit: pageSize,
	});
	const { mutate: remove } = useDeleteEquipmentType();
	const items = data?.data?.items ?? [];
	const total = data?.data?.pagination?.total ?? 0;

	return (
		<Table
			loading={isLoading}
			pagination={tablePagination({
				page: currentPage,
				limit: pageSize,
				total,
				onChange: (page, size) => setPage(page, size ?? pageSize),
			})}
			size="small"
			scroll={{ x: "max-content" }}
			dataSource={items}
			rowKey="id"
			locale={{
				emptyText: <EmptyState description="Texnika turlari topilmadi" />,
			}}
			columns={[
				{
					key: "#",
					title: "#",
					width: 60,
					align: "center",
					render: (_, __, index) => formatTableIndex(currentPage, pageSize, index),
				},
				{
					key: "name",
					title: "Nomi",
					dataIndex: "name",
				},
				{
					key: "code",
					title: "Kod",
					dataIndex: "code",
					width: 120,
				},
				{
					key: "actions",
					title: "Amallar",
					width: 80,
					align: "center",
					render: (_: unknown, record: EquipmentType) => (
						<Dropdown
							menu={{
								items: [
									{
										key: "edit",
										icon: <EditOutlined />,
										label: "Tahrirlash",
										onClick: () => onOpen(record),
									},
									{
										key: "delete",
										danger: true,
										label: (
											// biome-ignore lint/a11y/useKeyWithClickEvents: dropdown menu item
											// biome-ignore lint/a11y/noStaticElementInteractions: dropdown menu item
											<div onClick={(e) => e.stopPropagation()}>
												<Popconfirm
													title="O'chirish"
													description="Rostdan ham o'chirmoqchimisiz?"
													onConfirm={() => remove(record.id)}
													okText="Ha"
													cancelText="Yo'q"
													okButtonProps={{ danger: true }}
												>
													<div
														style={{
															width: "100%",
															display: "flex",
															alignItems: "center",
															gap: "8px",
														}}
													>
														<DeleteOutlined />
														<span>O&apos;chirish</span>
													</div>
												</Popconfirm>
											</div>
										),
									},
								],
							}}
							trigger={["click"]}
							placement="bottomRight"
						>
							<Button type="text" icon={<MoreOutlined />} size="small" />
						</Dropdown>
					),
				},
			]}
		/>
	);
}
